import { Button, Icon, Modal, Spinner } from '@iwoca/orion';
import handIcon from './handIcon.svg';
import { useState } from 'react';
import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchPostSharedRegisterInterest } from '@iwoca/lapi-client/iwocapay';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const BuyerMultiAccessBanner = () => {
    const stateKey = useStateKey();
    const [isOpen, setIsOpen] = useState(false);
    const [regeristering, setRegistering] = useState<
        'loading' | 'success' | 'fail' | null
    >(null);

    const openModal = () => {
        setIsOpen(true);
        tracking.ampli.buyerMultiAccessFakeDoor();
    };

    const registerInterest = async () => {
        setRegistering('loading');
        try {
            await fetchPostSharedRegisterInterest({
                stateKey: stateKey,
                feature: 'BUYER_MULTI_ACCESS'
            });
            setRegistering('success');
        } catch (e) {
            setRegistering('fail');
        }
    };

    return (
        <div className="box-border flex w-full items-start justify-start gap-l rounded-s border border-solid border-secondary-90 px-l py-s">
            <img
                src={handIcon}
                alt="hand with coins icon"
                className="w-[50px]"
            />
            <div className="flex flex-col">
                <button
                    onClick={openModal}
                    className="text-sm flex cursor-pointer items-center gap-xs border-none bg-transparent px-0 text-left font-bold text-primary-40"
                >
                    Want to add another user to your account?
                    <Icon
                        icon="angleRight"
                        fill="#205EAC"
                        className="min-w-l pt-2xs"
                    />
                </button>
                <span className="text-s font-reg">
                    Give someone else from your businesses access to use your
                    spending limit.
                </span>
            </div>
            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                title="We’re still working on this"
                closeIcon
                headerBar
            >
                <div className="flex flex-col gap-l font-reg min-m:items-start">
                    <div className="font-med">
                        Soon you’ll be able to give someone else from your
                        businesses access to use your spending limit from your
                        iwocaPay dashboard.
                    </div>
                    <Button
                        onClick={registerInterest}
                        disabled={
                            regeristering === 'loading' ||
                            regeristering === 'success'
                        }
                    >
                        Email me when this launches{' '}
                        {regeristering === 'loading' && (
                            <Spinner size="small" />
                        )}
                        {regeristering === 'success' && (
                            <Icon icon="checkDefault" />
                        )}
                    </Button>
                    <div>
                        If you have questions or are interested about this
                        feature, we’d love to hear from you. Just give us a call
                        on <a href="tel:+442037780549">0203 778 0549</a>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
